import React from "react"

/* App Pages */
export const Home = React.lazy(() => import("./Home"))

// wallets
export const WalletsOverview = React.lazy(
    () => import("./Wallets/WalletsOverview")
)
export const WalletsTopup = React.lazy(() => import("./Wallets/Topup"))
export const WalletsWithdraw = React.lazy(
    () => import("./Wallets/WalletsWithdraw")
)
export const WalletsUnclaim = React.lazy(
    () => import("./Wallets/WalletsUnclaim")
)

/* Swap Page */
export const Swap = React.lazy(() => import("./Swap"))

/* Shop Page */
export const Shop = React.lazy(() => import("./Shop/Shop"))
export const Purchases = React.lazy(() => import("./Shop/Purchases"))

/* Migrate Page */
export const Migrate = React.lazy(() => import("./Migrate"))

/* Referral Page */
export const ReferralPage = React.lazy(() => import("./Referral"))

// other

export const Settings = React.lazy(() => import("./Settings"))
export const Logout = React.lazy(() => import("./Logout"))

/* Auth Pages */
// login
export const Login = React.lazy(() => import("./Auth/Login"))

// signup
export const Signup = React.lazy(() => import("./Auth/Signup"))
// forgotpassword
export const ForgotPassword = React.lazy(() => import("./Auth/ForgotPassword"))
export const CreateNewPassword = React.lazy(
    () => import("./Auth/ForgotPassword/CreateNewPassword")
)

export const OurApps = React.lazy(() => import("./OurApps"))
export const Impersonate = React.lazy(() => import("./Impersonate"))
export const MaintenanceMode = React.lazy(() => import("./MaintenanceMode"))

/* 404 Page */
export const Error = React.lazy(() => import("./Error"))
